// Coffescript compilation

var base, base1;

window.debug = function () {
  var arg, i, len, ref, results;
  if (
    ((ref = window.console) != null ? ref.log : void 0) != null &&
    window.Settings.debug
  ) {
    if (window.console.log.apply != null) {
      return window.console.log.apply(console, arguments);
    } else {
      results = [];
      for (i = 0, len = arguments.length; i < len; i++) {
        arg = arguments[i];
        results.push(
          typeof console !== "undefined" && console !== null
            ? console.log(arg)
            : void 0,
        );
      }
      return results;
    }
  }
};

window.console || (window.console = {});

(base = window.console).time || (base.time = $.noop);

(base1 = window.console).timeEnd || (base1.timeEnd = $.noop);

export default window.debug;
